export const SESSION_ID_KEY = 'sessionId';
